import { VueModule } from '@Foundation';
import BeforeAfterV2 from './code/Scripts/components/before-after-v2';

export default VueModule({
  components: {
    BeforeAfterV2
  }
});
